import script from "./historyComponent.vue?vue&type=script&lang=js"
export * from "./historyComponent.vue?vue&type=script&lang=js"

import "./historyComponent.vue?vue&type=style&index=0&id=3bc7d61c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bc7d61c"]])

export default __exports__